import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";

const Modal = (props) => {

    const hide = () => {
        props.disactivate()
    }

    return (
        <div className={`modal${props.active ? "" : " hidden"}`}>
            <Link to="/" onClick={hide}>Home</Link>
            <Link to="/services" onClick={hide}>Services</Link>
            <Link to="/portfolio" onClick={hide}>Portfolio</Link>
            <Link to="/contact" onClick={hide}>Contact</Link>
        </div>
    )
}

Modal.defaultProps = {
    
};

export default Modal